import React from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Table } from 'reactstrap';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { showDateFormated } from 'utility/generic';
import { useMemo } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { handleSendGeneric } from 'services/generic';
import _ from 'lodash';
import { DeleteWithModalButton } from 'components/Table/ActionTable';

const QuebraDeLinhaComSpan = ({ texto }) => {
  const linhas = texto.split('\r\n');
  const linhasComSpan = linhas.map((linha, index) => (
    <React.Fragment key={index}>
      <span>{linha}</span>
      <br />
    </React.Fragment>
  ));

  return <div>{linhasComSpan}</div>;
};

export function TableVisitRecord({ id }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    async function getAllVisit() {
      const data = await handleSendGeneric(
        '/v1/visit-record/filter-all/CLIENT/' + id,
        'GET'
      );
      if (data !== undefined) {
        const sortedByNewestDate = _.orderBy(data, ['lastUpdate'], ['desc']);
        setData(sortedByNewestDate);
      }
    }

    getAllVisit();
  }, [id]);

  const columns = useMemo(
    () => [
      {
        Header: 'Evento',
        accessor: 'description',
        Cell: ({ cell: { value } }) => {
          return (
            <div>
              <QuebraDeLinhaComSpan texto={value} />
            </div>
          );
        },
      },
      {
        Header: 'Última Atualização',
        accessor: 'lastUpdate',
        Cell: ({ cell: { value } }) => (
          <span>{`${showDateFormated(value)}`}</span>
        ),
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <DeleteWithModalButton
              urlDelete={'/v1/visit-record/'}
              idDelete={actionId}
              listUpdate={setData}
            />
          );
        },
      },
    ],
    []
  );

  const cacheData = React.useMemo(() => data, [data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data: cacheData,
    },
    useGlobalFilter
  );
  const { globalFilter } = state;

  return (
    <>
      <GlobalFilter
        filter={globalFilter}
        setFilter={setGlobalFilter}
        urlNewItem={'/client/new'}
        disableButtomCreate={true}
      />
      <Table responsive hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} id={i}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '18px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Sem registros!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}
